import { isPasswordValid } from './passwordStrength'
import { EnrollmentForm } from '../types/enrollmentForm'

type TranslateFn = (key: string) => string

export function buildStructureRules(t: TranslateFn, getForm: () => EnrollmentForm) {
  return {
    companyName: [{ required: true, message: t('enrollment.rules.companyName'), trigger: 'blur' }],
    entityKind: [{ required: true, message: t('enrollment.rules.entityKind'), trigger: 'change' }],
    entityKindOther: [{
      validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
        if (getForm().entityKind === 'Autre' && !value?.trim()) {
          callback(new Error(t('enrollment.rules.entityKindOther')))
        } else callback()
      },
      trigger: 'blur'
    }],
    siret: [
      { required: true, message: t('enrollment.rules.siret'), trigger: 'blur' },
      {
        validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
          const digits = (value || '').replace(/\s/g, '')
          if (digits && !/^\d{14}$/.test(digits)) {
            callback(new Error(t('enrollment.rules.siretFormat')))
          } else callback()
        },
        trigger: 'blur'
      }
    ],
    adminFullName: [{ required: true, message: t('enrollment.rules.adminFullName'), trigger: 'blur' }],
    contactRole: [{ required: true, message: t('enrollment.rules.contactRole'), trigger: 'change' }],
    contactRoleOther: [{
      validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
        const role = getForm().contactRole
        if ((role === 'Autre' || !role) && !value?.trim()) {
          callback(new Error(t('enrollment.rules.contactRoleOther')))
        } else callback()
      },
      trigger: 'blur'
    }],
    adminEmail: [
      { required: true, message: t('enrollment.rules.adminEmail'), trigger: 'blur' },
      { type: 'email', message: t('enrollment.rules.emailFormat'), trigger: 'blur' }
    ],
    mobilePhone: [{ required: true, message: t('enrollment.rules.mobilePhone'), trigger: 'blur' }],
    password: [
      { required: true, message: t('enrollment.rules.password'), trigger: 'blur' },
      {
        validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
          if (value && !isPasswordValid(value)) {
            callback(new Error(t('enrollment.rules.passwordFormat')))
          } else callback()
        },
        trigger: 'blur'
      }
    ],
    passwordConfirmation: [
      { required: true, message: t('enrollment.rules.passwordConfirmation'), trigger: 'blur' },
      {
        validator: (_: unknown, value: string, callback: (err?: Error) => void) => {
          if (value !== getForm().password) {
            callback(new Error(t('enrollment.rules.passwordMismatch')))
          } else callback()
        },
        trigger: 'blur'
      }
    ],
    'billingAddress.street': [{ required: true, message: t('enrollment.rules.street'), trigger: 'blur' }],
    'billingAddress.city': [{ required: true, message: t('enrollment.rules.city'), trigger: 'blur' }],
    'billingAddress.zipcode': [{ required: true, message: t('enrollment.rules.zipcode'), trigger: 'blur' }],
    'billingAddress.country': [{ required: true, message: t('enrollment.rules.country'), trigger: 'change' }]
  }
}

export function buildDeliveryAddressRules(t: TranslateFn, prefix: string, addresses: { length: number }) {
  const rules: Record<string, unknown[]> = {}
  for (let i = 0; i < addresses.length; i++) {
    rules[`${prefix}.${i}.siteName`] = [{ required: true, message: t('enrollment.rules.siteName'), trigger: 'blur' }]
    rules[`${prefix}.${i}.street`] = [{ required: true, message: t('enrollment.rules.street'), trigger: 'blur' }]
    rules[`${prefix}.${i}.city`] = [{ required: true, message: t('enrollment.rules.city'), trigger: 'blur' }]
    rules[`${prefix}.${i}.zipcode`] = [{ required: true, message: t('enrollment.rules.zipcode'), trigger: 'blur' }]
  }
  return rules
}
